
    import React from 'react';
    import { useReportReasonSuspend,useReportReasonCreate, useReportReasonSoftDelete,useReportReasonMultipleSoftDelete, useReportReasonUpdate,useApproveReportReasonKYC,useUpdateKYCDocument  } from '../../queries/reportReason.queries';
    import ReportReason from './ReportReason';
    
    const ReportReasonContainer = () => {
    
      const {mutate:addRecord} = useReportReasonCreate();
      const {mutate:editRecord} = useReportReasonUpdate();
      const {mutate:deleteRecord} = useReportReasonSoftDelete();
      const {mutate:deleteRecords} = useReportReasonMultipleSoftDelete();
      const {mutate:reportedProfileSuspend} = useReportReasonSuspend();
      const {mutate:approveKYC} = useApproveReportReasonKYC();
      const {mutate:verifyKYCDocumentUpload} = useUpdateKYCDocument();
    
      const onAddRecord = (record) => {
        return new Promise((resolve,reject) => {
          addRecord(record, {
            onSuccess: async () => resolve('Record created successfully.'),
            onError: async (error) => reject(error?.message),
          });
        })
      };
    
      const onEditRecord = (record) => {
        return new Promise((resolve, reject) => {
          editRecord(
            record,
            {
              onSuccess: async () => resolve('Record updated successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };
    
      const onDeleteRecord = (record) => {
        return new Promise((resolve, reject) => {
          deleteRecord(
            record, 
            {
              onSuccess: async () => resolve('Record deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      const onMultiDelete = (record) => {
        return new Promise((resolve, reject) => {
          deleteRecords(
            record, 
            {
              onSuccess: async () => resolve('Records deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };
      const onReportReasonSuspend = (record) => {
        return new Promise((resolve, reject) => {
          record.isBlocked = true
          reportedProfileSuspend(
            record,
            {
              onSuccess: async () => resolve('Record updated successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };
      const onApproveKYC = (record) => {
        return new Promise((resolve, reject) => {
          approveKYC(
            record, 
            {
              onSuccess: async () => resolve('Records deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      const onKYCDocumentUpload = (record) => {
        return new Promise((resolve, reject) => {
          console.log("sgr")
          verifyKYCDocumentUpload(
            record, 
            {
              onSuccess: async () => resolve('Records deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      return (
        <ReportReason 
          addRecord={onAddRecord}
          deleteRecord={onDeleteRecord}
          deleteRecords={onMultiDelete}
          editRecord={onEditRecord}
          reportedProfileSuspend={onReportReasonSuspend}
          approveKYC={onApproveKYC}
          verifyKYCDocumentUpload ={onKYCDocumentUpload}
        />
      )
    }
    
    export default ReportReasonContainer;
    